import {LOAD_BAR} from '../../constants/loadBar';
import {CNPJ_TYPES} from '../../constants/typesMessages';

/**
 * Show Legal Name
 */
const LegalName = (responseData, messagesResponse) => {
  return messagesResponse.messages.push(
    ...[
      {
        text: responseData.ecBasicData.legalName
          ? responseData.ecBasicData.legalName
          : 'Não informado',
        target: 'cnpj-legal-name',
        label: 'Razão Social: ',
        type: 'message-receive'
      },
      {
        text: responseData.ecBasicData.fantasyName
          ? responseData.ecBasicData.fantasyName
          : 'Não informado',
        target: 'cnpj-fantasy-name',
        label: 'Nome Fantasia: ',
        type: 'message-receive'
      }
    ]
  );
};

/**
 * Show partners data
 */
const partnerList = (responseData, messagesResponse) => {
  let messageText = [];
  let numPartners = 0;

  if (responseData.partners.length > 0) {
    numPartners = responseData.partners.length;
    messageText = responseData.partners.map((partner) => {
      const showRole =
        partner.role !== '' ? `(${partner.role})` : '(Não informado)';
      return ` ${partner.partnerName} ${showRole}`;
    });
  }

  let showLabel = numPartners === 1 ? 'Proprietário' : 'Quadro societário';

  return messagesResponse.messages.push({
    text: `:${
      messageText.length > 0 ? messageText.toString() : 'Não informado'
    }`,
    target: 'cnpj-partners-names',
    label: showLabel,
    type: 'message-receive'
  });
};

/**
 * Show CNAE
 */
const cnaeList = (responseData, messagesResponse) => {
  return messagesResponse.messages.push({
    text: responseData.ecBasicData.primaryCnae
      ? responseData.ecBasicData.primaryCnae.replace(
          /^(\d{4})(\d{1})(\d{2}).*/,
          '$1-$2/$3'
        )
      : 'Não informado',
    label: 'CNAE: ',
    type: 'message-receive'
  });
};

/**
 * Show question confirmation of the data
 */
const questionEcCorrectly = (messagesResponse) => {
  return messagesResponse.messages.push(
    ...[
      {
        text: 'Importante: caso tenham acontecido mudanças no Quadro Societário da sua empresa, atualize as informações na Receita Federal, e depois atualizaremos seu cadastro.',
        label: 'Atenção: ',
        type: 'message-receive'
      },
      {
        text: 'As informações acima estão corretas?',
        label: 'Atenção: ',
        type: 'information-question'
      }
    ]
  );
};

/**
 * Function for CNPJ that has data in the Bureau
 */
export const showResponseCNPJ = (responseData) => {
  let messagesResponse = {
    messages: [
      {
        text: 'Encontrei as seguintes informações para o CNPJ digitado:',
        type: 'message-receive'
      }
    ]
  };

  LegalName(responseData, messagesResponse);

  partnerList(responseData, messagesResponse);

  cnaeList(responseData, messagesResponse);

  questionEcCorrectly(messagesResponse);

  return {
    ...messagesResponse,
    chatStageFlow: LOAD_BAR.CNPJ,
    ec: responseData,
    responseType: CNPJ_TYPES.CNPJ_FLOW,
    responseFlow: 'disabled'
  };
};

/**
 * Function for CNPJ that does not have data in the Bureau
 */
export const notInfoInBureau = (data) => {
  return {
    ec: {
      ...data
    },
    chatStageFlow: LOAD_BAR.CNPJ,
    messages: [
      {
        text: 'O CNPJ está correto?',
        type: 'cnpj-no-info-bureau-confirm'
      }
    ],
    responseType: 'disabled'
  };
};
